import * as types from "./types";

export const fetchingRentalPrice = () => ({
  type: types.FETCHING_RENTAL_PRICE,
  loading: true
});

export const errorFetchingRentalPrice = (error) => ({
  type: types.ERROR_FETCHING_RENTAL_PRICE,
  error: error,
  loading: false
});

export const fetchedRentalPrice = (price, circleId) => ({
  type: types.FETCHED_RENTAL_PRICE,
  price_details: price,
  circleId: circleId,
  loading: false
});

export const fetchingBookings = () => ({
  type: types.FETCHING_BOOKINGS,
  loading: true
});

export const deletingBooking = (booking) => ({
  type: types.DELETING_BOOKING,
  loading: true,
  booking
});

export const addingNewBooking = () => ({
  type: types.ADDING_BOOKING,
  loading: true
});

export const addedNewBooking = (booking) => ({
  type: types.ADDED_BOOKING,
  booking: booking,
  loading: false
});

export const deletedBooking = (booking) => ({
  type: types.DELETED_BOOKING,
  booking: booking,
  loading: false
});

export const fetchedBookings = (bookings, productId, rentals) => ({
  type: types.FETCHED_BOOKINGS,
  bookings: bookings,
  productId: productId,
  rentals: rentals,
  loading: false
});

export const errorFetchingBookings = (error) => ({
  type: types.ERROR_FETCHING_BOOKINGS,
  error: error,
  loading: false
});

export const errorAddingBooking = (error) => ({
  type: types.ERROR_ADD_BOOKING,
  error: error,
  loading: false
});

export const errorDeletingBooking = (error) => ({
  type: types.ERROR_DELETING_BOOKING,
  error: error,
  loading: false
});